'use client';

import type { CategoryPageData } from '../model/types/categoryPageData';
import type { CategoryPathType } from '../model/types/categoryPathsConfig';
import type { BreadcrumbItemType } from '@shared/types/global';

import { useRef } from 'react';

import { SEO_PATH } from '@screens/Category/config/seo';
import { useAppStore } from '@shared/hooks/redux';
import { SeoText } from '@widgets/SeoText';

import { initState } from '../model/slice/categorySlice';
import { Filter } from './Filter/Filter';
import { Products } from './Products/Products';
import { SubCategories } from './SubCategories/SubCategories';
import { Top } from './Top/Top';

export type CategoryProps = {
  breadcrumbs: BreadcrumbItemType[];
  data: CategoryPageData;
  category: CategoryPathType;
  categoryTitle: string;
  hideSubcategories?: boolean;
  subcategory?: string;
};

export const Category = ({
  breadcrumbs,
  data,
  categoryTitle,
  category,
  subcategory,
  hideSubcategories
}: CategoryProps) => {
  const store = useAppStore();
  const initialized = useRef(false);

  if (!initialized.current) {
    store.dispatch(initState(data));
    initialized.current = true;
  }

  return (
    <>
      <Top
        categoryTitle={categoryTitle}
        breadcrumbs={breadcrumbs}
      />
      {!hideSubcategories && <SubCategories data={category} />}
      <Filter />
      <Products />
      <SeoText>
        {subcategory
          ? SEO_PATH[data.category.translit].subcategories[subcategory.replaceAll('-', '_')]?.text
          : SEO_PATH[data.category.translit].text}
      </SeoText>
    </>
  );
};
